import React from 'react';
import { useBMP } from '../context/BMPContext';
import { useTranslation } from 'react-i18next';
import './QuotaCard.css';

export default function QuotaCard({ quota }) {
  const { t } = useTranslation();
  const { isProducer, bmpNavigate } = useBMP();
  const q = quota;

  const fruitLabel = q.farm_fruit_type === 'organico' ? t('mkt_organic')
    : q.farm_fruit_type === 'ambos' ? t('mkt_both_fruit')
    : t('mkt_conventional');

  const pct = q.available_boxes > 0
    ? Math.round((q.remaining_boxes / q.available_boxes) * 100) : 0;

  return (
    <div className="qcard" onClick={() => bmpNavigate('quota_detail', { quotaId: q.id, quota: q })}>
      {/* Product image area */}
      <div className="qcard-img">
        {q.farm_cover_url
          ? <img src={q.farm_cover_url} alt={q.farm_name} className="qcard-cover-img" />
          : <span className="qcard-img-emoji">&#127820;</span>
        }
        <span className={`qcard-zone qcard-zone--${q.farm_zone}`}>{q.farm_zone_display}</span>
        {q.status === 'partially_sold' && <span className="qcard-hot">{t('bmp_selling_fast')}</span>}
      </div>

      {/* Body */}
      <div className="qcard-body">
        {/* Seller info */}
        {!isProducer && (
          <div className="qcard-seller" onClick={e => { e.stopPropagation(); bmpNavigate('producer_store', { username: q.producer_username }); }}>
            {q.producer_photo
              ? <img src={q.producer_photo} alt="" className="qcard-seller-img" />
              : <span className="qcard-seller-initial">{(q.producer_username || '?')[0].toUpperCase()}</span>
            }
            <span className="qcard-seller-name">{q.producer_company || q.producer_username}</span>
            <span className="qcard-seller-link">{t('bmp_visit_store')}</span>
          </div>
        )}

        {/* Product title */}
        <h3 className="qcard-title">{q.farm_name}</h3>
        {q.farm_city && <span className="qcard-location">{q.farm_city}</span>}

        {/* Tags */}
        <div className="qcard-tags">
          <span className="qcard-tag">{fruitLabel}</span>
          <span className="qcard-tag">{t('mkt_week_short')} {q.week_start}</span>
        </div>

        {/* Stock / availability */}
        <div className="qcard-stock">
          <div className="qcard-stock-bar">
            <div className="qcard-stock-fill" style={{ width: `${pct}%` }} />
          </div>
          <div className="qcard-stock-info">
            <span className="qcard-stock-num">{q.remaining_boxes.toLocaleString('es-EC')}</span>
            <span className="qcard-stock-label">{t('bmp_boxes_available_short')}</span>
            <span className="qcard-stock-of">/ {q.available_boxes.toLocaleString('es-EC')}</span>
          </div>
        </div>

        {/* Footer */}
        <div className="qcard-footer">
          <span className={`qcard-status qcard-status--${q.status}`}>{q.status_display}</span>
          {isProducer && q.bids_count > 0 && (
            <span className="qcard-bids">{q.bids_count} {t('bmp_bids')}</span>
          )}
        </div>
      </div>
    </div>
  );
}
